/** @format */

import {CommonChartData} from 'components/charts/multiline-chart/model/charts';

import {PointName} from 'components/charts/multiline-chart/model/common';

import {roundFloatNumber} from 'helpers/numberHelpers';

import {ChartIds} from '../models/chartIds';
import {GraphStat} from '../models/common';
import {CHARTS_PREDICATES} from '../constants/predicates';
import {WIDGETS_LIST} from '../constants/widgets';
import {ALL_SENSOR_CHART_IDS} from '../constants/allChartIds';
import {getSensorPrimaryValue} from './getSensorPrimaryValue';
import {SensorsList} from '../helpers/sensors/types';

export interface MapChartDataPointOptions {
  graphStat?: GraphStat;
  sensors?: SensorsList;
  pointName: PointName;
  chartId: ChartIds;
  previousValue: number;
  currentDate: string;
  needForecast: boolean;
}

const mapChartDataPoint = ({
  graphStat,
  sensors,
  pointName,
  currentDate,
  chartId,
  previousValue,
  needForecast,
}: MapChartDataPointOptions): CommonChartData => {
  const result: CommonChartData = {
    name: pointName,
  };

  if (!graphStat || (needForecast && pointName !== '0000')) {
    return result;
  }

  // Обычное primary значение

  const isSensor = ALL_SENSOR_CHART_IDS.includes(chartId);

  result.primary =
    isSensor && sensors ? getSensorPrimaryValue(chartId, sensors[currentDate]) : graphStat[chartId];

  // Если существует альтернативный график (типа "Сумма" вместо "Дня"), то вычисляем secondary значение

  const predicates = CHARTS_PREDICATES[chartId];
  const isSecondary = Boolean(predicates && predicates.secondaryPredicate);
  if (isSecondary) {
    result.secondary = predicates!.secondaryPredicate!(
      result.secondary ?? result.primary,
      previousValue,
    );
  }

  // Округляем готовые значения

  const {roundNumberBy} = WIDGETS_LIST[chartId];

  result.primary = roundFloatNumber(result.primary, roundNumberBy);

  if (result.secondary !== undefined) {
    result.secondary = roundFloatNumber(result.secondary, roundNumberBy);
  }

  return result;
};

export default mapChartDataPoint;
